interface TableOptions {
    tableHeight: number;
    headerHeight: number;
    currentRowHeight: number;
    footerScrollBarHeight: number;
}

export const getEmptyRowDataIndexByCurrentScrollPosition = <T>(
    currentScrollPosition: number,
    data: (T | null)[],
    opts: TableOptions
): number | undefined => {
    const { tableHeight, headerHeight, currentRowHeight, footerScrollBarHeight } = opts;
    let firstRowIndex, lastRowIndex;

    if (currentScrollPosition === 0) {
        firstRowIndex = lastRowIndex = currentScrollPosition;
    } else {
        // первый видимый элемент таблички
        firstRowIndex = Math.floor(currentScrollPosition / currentRowHeight);
        // последний видимый элемент таблички
        lastRowIndex =
            Math.ceil((currentScrollPosition + tableHeight - headerHeight - footerScrollBarHeight) / currentRowHeight) -
            1;
    }

    if (!data[firstRowIndex]) {
        return firstRowIndex;
    }

    if (!data[lastRowIndex]) {
        return lastRowIndex;
    }

    return undefined;
};
